import {
  Box,
  BoxProps,
  ColorOptions,
  getOS,
  Icon,
  Image,
  ModalDialog,
  ModBox,
  Spacer,
  Text,
  TextProps
} from '@jfs/ui-new'
import { useFocusEffect, useNavigation } from '@react-navigation/core'
import { FC, default as React, useCallback, useEffect, useRef, useState } from 'react'
import { FlatList } from 'react-native'
import { UpiIcon } from '../../assets/images/svg/Upi'
import { Button } from '../../comps/Button'
import { EmptyView } from '../../comps/EmptyView'
import { Modal } from '../../comps/Modal'
import { PaySecurelyButton } from '../../comps/PaySecurelyButton'
import { useLazyApiData, useStores } from '../../data/store'
import {
  analyticsEvent,
  convertHexToRGBA,
  formatAmount,
  getWindow,
  isIFrame,
  isMobileDevice,
  MessageTypes,
  sendErrorIfNotIframe
} from '../../utils'
import { pages } from '../../utils/constants'
import { UPIInputModal } from './UPIInputModal'
import { UPIInputModalDesktop } from './UPIInputModalDesktop'
import { UPIListItem } from './UPIListItem'

const DELAY: number = 5000
const STAUS_CHECK_COUNT: number = 6
const UPIAPP_TIMEOUT: number = 5000

const UPI: FC = ({ route }: any) => {
  const {
    checkPaymentStatus,
    theme,
    netAmount,
    intentid,
    txnId,
    paymentStatus,
    retUrl,
    setMessage,
    savedCardApiStatus,
    getSavedCards,
    getUPIIntent,
    upiIntentUrl,
    isUpiIntentAllowed,
    isCollectVpaSupported,
    redirectUrl,
    cancelIntent,
    upiMaxRetryLimit,
    updateMaxRetryLimit,
    paymentsSupported,
  } = useStores((root) => ({
    theme: root.config.merchantTheme,
    netAmount: root.transaction.amount.netAmount,
    intentid: root.transaction.id.intentId,
    checkPaymentStatus: root.getIntentStatusApi,
    txnId: root.transaction.id.id,
    paymentStatus: root.transaction.paymentStatus,
    retUrl: root.transaction.getMerchantRedirectingUrl(),
    getUPIIntent: root.transaction.getUPIIntent,
    setMessage: root.message.setMessage,
    getSavedCards: root.getSavedCards,
    savedCardApiStatus: root.config.savedCardApiStatus,
    upiIntentUrl: root.transaction.upiIntent,
    isUpiIntentAllowed: root.merchant.isUpiIntentAllowed,
    isCollectVpaSupported: root.merchant.isCollectVpaSupported,
    cancelIntent: root.cancelIntentApi,
    redirectUrl: root.transaction.initiatingEntity.returnUrl,
    upiMaxRetryLimit: root.merchant.preferences.upiMaxRetryLimit,
    updateMaxRetryLimit: root.merchant.updateMaxRetryLimit,
    paymentsSupported: root.merchant.paymentsSupported,
  }))
  console.log('route', route)

  const [isSelected, setIsSelected] = useState({
    isUPIAppSelected: false,
    isUPIIdSelected: false,
  })
  const [installedUpiAppList, setInstalledUpiAppList]: any = React.useState()
  const [initialLoading, setInitialLoading] = useState(true)
  const [selectedUpi, setSelectedUpi] = React.useState<any>({})
  const upiRef = useRef<any>()
  const [showModal, setShowModal] = useState(false)
  const [loadingMSG, setLoadingMSG] = useState("Finding UPI App's")
  const [showPaymentLoader, setShowPaymentLoader] = useState(false)
  const [showRetryModal, setShowRetryModal] = useState({ visible: false, message: 'Sorry, your payment was declined' })
  const [checkPaymentStatusApi, { state: paymentStatusState }] = useLazyApiData(checkPaymentStatus)
  const [cancelIntentApi, { state }] = useLazyApiData(cancelIntent)
  const navigation = useNavigation()

  useEffect(() => {
    if (state === 'fulfilled' || state === 'rejected') {
      if (isIFrame()) {
        window.parent.postMessage(
          {
            txnId: 0,
            intentid,
            status: 'bounced',
            message: 'Retry attempts exceeded',
          },
          '*',
        )
      } else {
        sendErrorIfNotIframe('bounced', 'Retry attempts exceeded', redirectUrl, intentid)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  const navigateToMerchant = useCallback(() => {
    if (isIFrame()) {
      window.parent.postMessage(
        {
          txnId,
          intentid,
          status: 'completed',
          message: '',
          rUrl: retUrl,
        },
        '*',
      )
    } else {
      //Linking.openURL(retUrl)
      window.location.href = retUrl
    }
  }, [intentid, retUrl, txnId])

  useEffect(() => {
    if (savedCardApiStatus === 'initial') {
      getSavedCards()
    }
  }, [getSavedCards, savedCardApiStatus])

  useEffect(() => {
    if (paymentStatusState === 'fulfilled') {
      if (paymentStatus === 'SUCCESS') {
        navigateToMerchant()
      } else if (paymentStatus === 'FAILED' || paymentStatus === 'failed') {
        setShowPaymentLoader(false)
        setShowRetryModal({ visible: true, message: 'Last payment  was  unsucessfull.' })
        // navigateToMerchant()
      } else if (upiRef?.current?.apiCount < STAUS_CHECK_COUNT && upiRef.current.isShowPaymentLoader) {
        setTimeout(() => {
          upiRef.current = {
            ...upiRef.current,
            apiCount: upiRef?.current?.apiCount + 1,
          }
          checkPaymentStatusApi()
        }, DELAY)
      } else if (upiRef?.current?.apiCount >= STAUS_CHECK_COUNT) {
        if (upiRef.current.isShowPaymentLoader) {
          upiRef.current = {
            ...upiRef.current,
            isShowPaymentLoader: false,
          }
          setShowPaymentLoader(false)
        }
        setMessage('Please try with different payment instrument', MessageTypes.error)
      }
    }
  }, [checkPaymentStatusApi, navigateToMerchant, paymentStatus, paymentStatusState, setMessage])

  const onUpiAppsListRecived = (upiList: any) => {
    upiList = JSON.parse(upiList)
    setInstalledUpiAppList(upiList)
    if (upiList?.length === 0 && !isCollectVpaSupported && paymentsSupported?.length === 1) {
      navigation.navigate(pages.ErrorView, {
        title: 'No supported app found for UPI Intent',
        error: 'Contact the merchant',
        rUrl: retUrl,
      })
      // window.location.href = retUrl
    }
  }

  const getQueryParmsFromUrl = (url: any) => {
    const params = url.split('#')[0].split('&')
    const dict: any = {}
    let elem = []
    for (var i = params.length - 1; i >= 0; i--) {
      elem = params[i].split('=')
      dict[elem[0]] = elem[1]
    }
    return dict
  }

  const onResult = (result: any) => {
    const response = JSON.parse(result)?.response
    if (response && response.length > 0) {
      const paymentStatus = getQueryParmsFromUrl(response)?.Status
      if (paymentStatus === 'SUCCESS') {
        //navigateToMerchant()
        checkPaymentStatusApi()
      } else if (paymentStatus === 'FAILED' || paymentStatus === 'failed' || paymentStatus === 'FAILURE') {
        setShowPaymentLoader(false)
        setShowRetryModal({ visible: true, message: 'Sorry, your payment was declined' })
      } else {
        checkPaymentStatusApi()
      }
    } else {
      setShowPaymentLoader(false)
      setShowRetryModal({ visible: true, message: 'Operation Cancelled By User' })
    }
    //
  }

  window.onResult = onResult
  window.onUpiAppsListRecived = onUpiAppsListRecived

  useEffect(() => {
    if (isMobileSDK() && isUpiIntentAllowed) {
      getWindow().JioPaymentWebViewInterface.postMessage(
        JSON.stringify({ event: 'GET_INSTALLED_UPI_APPS', onResult: 'onUpiAppsListRecived' }),
      )
    }
  }, [isUpiIntentAllowed])

  useEffect(() => {
    setTimeout(() => {
      setInitialLoading(false)
    }, 500)
  }, [])

  const focusInHandler = () => {
    if (!isMobileSDK()) {
      updateMaxRetryLimit(upiMaxRetryLimit - 1)
    }
    upiRef.current = {
      ...upiRef.current,
      isUPIAppOpened: true,
      apiCount: 1,
    }
    setLoadingMSG('Payment in Progress.')
    window.removeEventListener('focus', focusInHandler)
    checkPaymentStatusApi()
  }

  const focusOutHandler = () => {
    upiRef.current = {
      ...upiRef.current,
      isUPIAppOpened: true,
    }
    window.removeEventListener('blur', focusOutHandler)
  }

  const handleUPIAppOpen = () => {
    if (!upiRef.current.isUPIAppOpened) {
      upiRef.current = {
        ...upiRef.current,
        isShowPaymentLoader: false,
      }
      setShowPaymentLoader(false)
      setMessage(
        'Not able to find UPI APP in your device. Please try with different payment instrument',
        MessageTypes.error,
      )
    }
  }

  const startTimer = () => {
    setTimeout(() => handleUPIAppOpen(), UPIAPP_TIMEOUT)
  }

  const handleProceed = async () => {
    //TODO: DELETE THIS - SAMPLE API RESPONSE OF QR
    //   {
    //     "status": "SUCCESS",
    //     "qr": "upi://pay?pa=10232760@jiopartner&pn=Online%20UPI&tr=10072213958036835000&tn=null&am=1&mode=02&orgId=000000&purpose=00&mc=4904&qrMedium=02&JioPay=JIOPAY10682213957883715000&sign=WaFRPln10DARAe+aM2LucgaehwiJUbFVxn1LWEFAor/+UMUVJgPksbPysJMnbPw9sO/le8A4WKMzg+U4rHC4wsfNdNrS+mnQ5tUc86G9ecxxYzSA5q370c3aIRd096YvDK8+xhcMRciT3cwkrhWp0CYKQblYHE+bsd8wFcPW0RaSlFKLFliVLUvhn1UcdZo1WxB/P+TtIIpVjeyVt7J7uoynIEytWfU0WBdR48I+zr9Ccg8M51YtPBN+9iT3fV/XKB0qraJqFhLTu2NZZSdM+Op71tp3lAhmW03B8+9/MrinyLp8eM0FW9JpX3aaQ7F7nYC+lp1KZ3MPSNy5Be93+A==",
    //     "vpa": "10232760@jiopartner",
    //     "businessName": "Online UPI",
    //     "qrId": "JIOPAY10682213957883715000"
    // }

    if (upiMaxRetryLimit <= 0) {
      setMessage('Max Retry Limit Exceeded', MessageTypes.error)
      cancelIntentApi()
    } else if (isSelected.isUPIAppSelected) {
      analyticsEvent('pay_button_pressed', { mode: 'upi_intent', amount: netAmount })
      // let url = `upi://pay?pa=${vpa}&mc=${mcc}&tr=${intentid}&am=${netAmount}&cu=INR#Intent;scheme=upi;end;`
      let url = `${upiIntentUrl}#Intent;scheme=upi;end;`
      if (!upiIntentUrl) {
        const res = await getUPIIntent()
        if (!res.qr) {
          return
        } else {
          url = `${res.qr}#Intent;scheme=upi;end;`
        }
      }
      if (isMobileSDK()) {
        setTimeout(() => {
          updateMaxRetryLimit(upiMaxRetryLimit - 1)
        }, 100)
        getWindow().JioPaymentWebViewInterface.postMessage(
          JSON.stringify({
            event: 'MAKE_UPI_PAYMENT',
            onResult: 'onResult',
            uri: url,
            package: selectedUpi.packageName,
          }),
        )
        if (getOS() === 'ios') {
          window.addEventListener('focus', focusInHandler, false)
          window.addEventListener('blur', focusOutHandler, false)
        }
      } else {
        upiRef.current = {
          isUPIAppOpened: false,
          isShowPaymentLoader: true,
        }
        // const url = `intent://pay?pa=${vpa}&mc=${mcc}&tr=${intentid}&am=${netAmount}&cu=INR#Intent;scheme=upi;end;`
        window.location.href = url.replace('upi://', 'intent://')
        startTimer()
        window.addEventListener('focus', focusInHandler, false)
        window.addEventListener('blur', focusOutHandler, false)
      }
      setShowPaymentLoader(true)
    } else if (isSelected.isUPIIdSelected) {
      setShowModal(true)
    }
  }

  const isMobileSDK = () => {
    return !!window.JioPaymentWebViewInterface
  }

  const isMobileChrome = () => {
    return !isMobileSDK() && isMobile && !!window.chrome
  }

  if (
    savedCardApiStatus === 'initial' ||
    savedCardApiStatus === 'pending' ||
    initialLoading ||
    (isMobileSDK() && isUpiIntentAllowed && installedUpiAppList?.length === undefined)
  ) {
    return <Loader state="pending" show={true} theme={theme} />
  }

  const navigatorObj: any = navigator
  const isMobile = isMobileDevice();
  return (
    <Box flex={1} backgroundColor={theme.bodyBgColor as ColorOptions}>
      {isUpiIntentAllowed && (
        <>
          <Box flex={1} overflowY="scroll">
            <SDKUPIList
              show={isMobileSDK() && installedUpiAppList?.length !== 0}
              theme={theme}
              installedUpiAppList={installedUpiAppList}
              setSelectedUpi={(upi: any) => setSelectedUpi(upi)}
              setIsSelected={(isUPIAppSelected: boolean, isUPIIdSelected: boolean) =>
                setIsSelected({ isUPIAppSelected, isUPIIdSelected })
              }
              isUPIAppSelected={isSelected.isUPIAppSelected}
              isUPIIdSelected={isSelected.isUPIIdSelected}
              amount={netAmount}
              onClickProceed={handleProceed}
              packageName={selectedUpi.packageName}
              isCollectVpaSupported={isCollectVpaSupported}
            />
            <MobileChromeUpiView
              show={isMobileChrome()}
              theme={theme}
              isUPIAppSelected={isSelected.isUPIAppSelected}
              setIsSelected={(isUPIAppSelected: boolean, isUPIIdSelected: boolean) =>
                setIsSelected({ isUPIAppSelected, isUPIIdSelected })
              }
              setSelectedUpi={(upi: any) => setSelectedUpi(upi)}
              isUPIIdSelected={isSelected.isUPIIdSelected}
              amount={formatAmount(netAmount)}
              onClickProceed={handleProceed}
              isCollectVpaSupported={isCollectVpaSupported}
            />

            {/* Runs on desktop  */}
            <ModBox
              flex={1}
              backgroundColor={theme.bodyBgColor as ColorOptions}
              show={
                (installedUpiAppList?.length === 0 || !isMobileSDK()) && !isMobileChrome()
              }>
              <UPIInputModalDesktop show={!isMobile} amount={netAmount} />
              <UPIInputModal show={isMobile && isCollectVpaSupported} onDismiss={() => { }} isDirectUPI={true} />
            </ModBox>
          </Box>
          <ShowPaymentLoader
            msg={loadingMSG}
            show={showPaymentLoader}
            theme={theme}
            selectedUpi={selectedUpi}
            dismiss={() => {
              console.log('onDismiss showpayment loader')
              upiRef.current = {
                ...upiRef.current,
                isShowPaymentLoader: false,
              }
              setLoadingMSG("Finding UPI App's")
              setShowPaymentLoader(false)
            }}
          />
        </>
      )}
      <UPIInputModal show={showModal} onDismiss={() => setShowModal(!showModal)} />
      <RetryModel
        show={showRetryModal.visible}
        theme={theme}
        dismiss={() => setShowRetryModal({ ...showRetryModal, visible: false })}
        message={showRetryModal.message}
      />
    </Box>
  )
}

const Loader = ({ state, onRetry, message, show = false, theme }: any) => {
  return <EmptyView state={state} onRetry={onRetry} message={message} show={show} theme={theme} />
}

const BottomView = ({
  theme,
  setSelectedUpi,
  setIsSelected,
  isUPIIdSelected,
}: {
  theme: any
  setSelectedUpi: (selectedUPI: any) => void
  setIsSelected: (isUPIAppSelected: boolean, isUPIIdSelected: boolean) => void
  isUPIIdSelected: boolean
  isUPIAppSelected: boolean
  amount: string
  onClickProceed: () => void
}) => {
  const style = styles(theme)
  return (
    <>
      <Box
        padding={24}
        paddingRight={24}
        paddingLeft={16}
        underlayColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}
        onPress={() => {
          setSelectedUpi({})
          setIsSelected(false, true)
        }}>
        <Box flexDirection="row" paddingLeft={8}>
          <UpiIcon size={18} selected={true} />
          <Box flex={1} marginLeft={16}>
            <Text {...style.upiIntentText(isUPIIdSelected)}>Pay using UPI Id / UPI Number</Text>
          </Box>

          <Box justifyContent="flex-end">
            <Icon
              id="ROUND_TICK_FILLED"
              color={(isUPIIdSelected ? theme?.brandColor : 'TRANSPARENT') as ColorOptions}
              size={20}
            />
          </Box>
        </Box>
        <Box paddingTop={32} paddingRight={8}>
          <Text
            fontSize={12}
            fontFamily="jioType-medium"
            color={convertHexToRGBA(theme.bodyTextColor, 50) as ColorOptions}
            lineHeight={20}>
            {'Pay through recipient UPI ID/UPI Number, save it for easy & quick access for future use.'}
          </Text>
        </Box>
      </Box>
    </>
  )
}

const SDKUPIList = ({
  show,
  theme,
  installedUpiAppList,
  setSelectedUpi,
  setIsSelected,
  isUPIAppSelected,
  isUPIIdSelected,
  amount,
  onClickProceed,
  packageName,
  isCollectVpaSupported,
}: {
  show: boolean
  theme: any
  installedUpiAppList: any
  setSelectedUpi: (upi: any) => void
  setIsSelected: (isUPIAppSelected: boolean, isUPIIdSelected: boolean) => void
  isUPIAppSelected: boolean
  isUPIIdSelected: boolean
  amount: string
  onClickProceed: () => void
  packageName: string
  isCollectVpaSupported: boolean
}) => {
  const _onUpiListItemPress = (item: any) => {
    setSelectedUpi(item)

    setIsSelected(true, false)
  }

  const _renderUPIList = ({ item }: any) => (
    <UPIListItem item={item} theme={theme} onItemPress={_onUpiListItemPress} selectedUpiPackageName={packageName} />
  )

  if (!show) {
    return null
  }
  const style = styles(theme)
  return (
    <>
      <Box flex={1} overflowY="scroll">
        <Box flexDirection={'column'} marginBottom={24}>
          <Box flexDirection="row" marginVertical={12} marginLeft={24}>
            <Text {...style.mobileUpiText}>Pay by any UPI app</Text>
          </Box>
          <FlatList data={installedUpiAppList} renderItem={_renderUPIList} />
        </Box>
        {isCollectVpaSupported && (
          <BottomView
            theme={theme}
            setSelectedUpi={setSelectedUpi}
            setIsSelected={(isUPIAppSelected: boolean, isUPIIdSelected: boolean) =>
              setIsSelected(isUPIAppSelected, isUPIIdSelected)
            }
            isUPIAppSelected={isUPIAppSelected}
            isUPIIdSelected={isUPIIdSelected}
            amount={amount}
            onClickProceed={onClickProceed}
          />
        )}
      </Box>
      <Box {...style.separatorStyle} />
      <Box {...style.payBtnMobile}>
        <PaySecurelyButton
          disabled={!isUPIAppSelected && !isUPIIdSelected}
          amount={amount}
          testID={'upiPaySecurelyBtn'}
          onPress={onClickProceed}
          isLoading={false}
        />
      </Box>
    </>
  )
}

const MobileChromeUpiView = ({
  show,
  theme,
  isUPIAppSelected,
  setIsSelected,
  setSelectedUpi,
  isUPIIdSelected,
  amount,
  onClickProceed,
  isCollectVpaSupported,
}: {
  show: boolean
  theme: any
  isUPIAppSelected: boolean
  setIsSelected: (isUPIAppSelected: boolean, isUPIIdSelected: boolean) => void
  setSelectedUpi: (upi: any) => void
  isUPIIdSelected: boolean
  amount: string
  onClickProceed: () => void
  isCollectVpaSupported: boolean
}) => {
  const style = styles(theme)

  const { isNativeUpiHasHigherRank } = useStores((root) => ({
    isNativeUpiHasHigherRank: root.isNativeUpiHasHigherRank,
  }))

  if (!show) {
    return null
  }

  return (
    <>
      {isNativeUpiHasHigherRank() && (
        <Box flex={1} overflowY="scroll">
          <Box
            paddingVertical={24}
            paddingRight={32}
            paddingLeft={16}
            underlayColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}
            onPress={() => {
              setIsSelected(true, false)
            }}>
            <Box flexDirection="row" paddingLeft={8}>
              <UpiIcon size={18} selected={true} />
              <Box flex={1} marginLeft={16}>
                <Text {...style.upiIntentText(isUPIAppSelected)}>Pay by any UPI app</Text>
              </Box>

              <Box justifyContent="flex-end" alignItems="center">
                <Icon
                  id="ROUND_TICK_FILLED"
                  color={(isUPIAppSelected ? theme?.brandColor : 'TRANSPARENT') as ColorOptions}
                  size={20}
                />
              </Box>
            </Box>
            <Box paddingTop={32} paddingRight={8}>
              <Text
                fontSize={12}
                fontFamily="jioType-medium"
                color={convertHexToRGBA(theme.bodyTextColor, 50) as ColorOptions}
                lineHeight={20}>
                Get the convenience of paying using any one of the UPI apps, installed on your mobile.
              </Text>
            </Box>
          </Box>
          {isCollectVpaSupported && (
            <>
              <Box {...style.separatorStyle} />
              <BottomView
                theme={theme}
                setSelectedUpi={setSelectedUpi}
                setIsSelected={(isUPIAppSelected: boolean, isUPIIdSelected: boolean) =>
                  setIsSelected(isUPIAppSelected, isUPIIdSelected)
                }
                isUPIAppSelected={isUPIAppSelected}
                isUPIIdSelected={isUPIIdSelected}
                amount={amount}
                onClickProceed={onClickProceed}
              />
            </>
          )}
        </Box>
      )}
      {!isNativeUpiHasHigherRank() && (
        <Box flex={1} overflowY="scroll">
          {isCollectVpaSupported && (
            <>
              <Box {...style.separatorStyle} />
              <BottomView
                theme={theme}
                setSelectedUpi={setSelectedUpi}
                setIsSelected={(isUPIAppSelected: boolean, isUPIIdSelected: boolean) =>
                  setIsSelected(isUPIAppSelected, isUPIIdSelected)
                }
                isUPIAppSelected={isUPIAppSelected}
                isUPIIdSelected={isUPIIdSelected}
                amount={amount}
                onClickProceed={onClickProceed}
              />
            </>
          )}
          <Box
            paddingVertical={24}
            paddingRight={32}
            paddingLeft={16}
            underlayColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}
            onPress={() => {
              setIsSelected(true, false)
            }}>
            <Box flexDirection="row" paddingLeft={8}>
              <UpiIcon size={18} selected={true} />
              <Box flex={1} marginLeft={16}>
                <Text {...style.upiIntentText(isUPIAppSelected)}>Pay using UPI Apps</Text>
              </Box>

              <Box justifyContent="flex-end" alignItems="center">
                <Icon
                  id="ROUND_TICK_FILLED"
                  color={(isUPIAppSelected ? theme?.brandColor : 'TRANSPARENT') as ColorOptions}
                  size={20}
                />
              </Box>
            </Box>
            <Box paddingTop={32} paddingRight={8}>
              <Text
                fontSize={12}
                fontFamily="jioType-medium"
                color={convertHexToRGBA(theme.bodyTextColor, 50) as ColorOptions}
                lineHeight={20}>
                Get the convenience of paying using any one of the UPI apps, installed on your mobile.
              </Text>
            </Box>
          </Box>
        </Box>
      )}
      <Box {...style.separatorStyle} />
      <Box {...style.payBtnMobile}>
        <PaySecurelyButton
          disabled={!isUPIAppSelected && !isUPIIdSelected}
          amount={amount}
          testID={'upiPaySecurelyBtn'}
          onPress={onClickProceed}
          isLoading={false}
        />
      </Box>
    </>
  )
}

const ShowPaymentLoader = ({
  msg,
  show,
  theme,
  dismiss,
  selectedUpi,
}: {
  msg: string
  show: boolean
  theme: any
  dismiss: () => void
  selectedUpi: any
}) => {
  const { isModalDisplaying, closeModal, updateCancelModal, updateModalDisplaying } = useStores((root) => ({
    isModalDisplaying: root.config.isMoalDisplaying,
    closeModal: root.config.closeModal,
    updateCancelModal: root.config.updateCancelModal,
    updateModalDisplaying: root.config.updateModalDisplaying,
  }))

  const onModalDismiss = () => {
    dismiss()
  }

  useFocusEffect(() => {
    if (!isModalDisplaying && show) {
      updateModalDisplaying(true)
    }
  })

  useEffect(() => {
    if (closeModal) {
      updateModalDisplaying(false)
      updateCancelModal(false)
      dismiss()
    }
  }, [closeModal, dismiss, updateCancelModal, updateModalDisplaying])

  const style = styles(theme)

  if (!show) {
    return null
  }

  return (
    <Modal type={'Bottom'} show={show} isFullWidth={false} onDismiss={onModalDismiss} theme={theme}>
      <Box pv={32} ph={24}>
        <Box flexDirection="row">
          {selectedUpi.base64AppIcon && (
            <Image source={'data:image/png;base64, ' + selectedUpi.base64AppIcon} width={24} height={24} />
          )}
          <Box
            flexDirection={'row'}
            justifyContent="space-between"
            flex={1}
            paddingLeft={selectedUpi.appName ? 16 : 0}
            marginTop={4}>
            <Text {...style.upiAppTitle}>{'Pay using: ' + (selectedUpi.appName ?? 'UPI App')}</Text>
            <Box onPress={onModalDismiss} underlayColor={convertHexToRGBA(theme.bodyTextColor, 10) as ColorOptions}>
              <Icon id={'CLOSE'} size={16} color={convertHexToRGBA(theme.bodyTextColor, 50) as ColorOptions} />
            </Box>
          </Box>
        </Box>
        <Box paddingTop={24} ph="5%" width={'100%'} testID={'toastMsg'}>
          <Loader type="large" color={theme?.brandColor as ColorOptions} theme={theme} />
          <Spacer size={24} />
          <Text {...style.paymentProgress}>{msg}</Text>
          <Spacer size={12} />
          {selectedUpi.appName && (
            <Text {...style.paymentProgress}>
              {'Open your' + selectedUpi.appName + 'app to complete the payment request.'}
            </Text>
          )}
        </Box>
      </Box>
    </Modal>
  )
}

const RetryModel = ({
  show,
  theme,
  dismiss,

  message,
}: {
  show: boolean
  theme: any
  dismiss: () => void

  message: any
}) => {
  const onModalDismiss = () => {
    dismiss()
  }

  const style = styles(theme)

  if (!show) {
    return null
  }

  return (
    <ModalDialog type={'Bottom'} show={show} isFullWidth={false} onDismiss={onModalDismiss} theme={theme}>
      <Box pv={32} ph={24}>
        <Box flexDirection={'row'} justifyContent="flex-end">
          <Box onPress={onModalDismiss} underlayColor={convertHexToRGBA(theme.bodyTextColor, 10) as ColorOptions}>
            <Icon id={'CLOSE'} size={16} color={convertHexToRGBA(theme.bodyTextColor, 50) as ColorOptions} />
          </Box>
        </Box>
        <Box
          paddingTop={24}
          ph="5%"
          width={'100%'}
          testID={'toastMsg'}
          flexDirection="column"
          alignItems="center"
          justifyContent="center">
          <Icon id={'INFO'} size={32} color={'YELLOW'} />
          <Spacer size={12} />

          <Text {...style.paymentProgress} fontSize={18}>
            {message}
          </Text>
          <Spacer size={32} />
          <Box flexDirection="column" width="100%">
            <Box paddingHorizontal={24}>
              <Button
                type="secondary"
                isFull={true}
                title="Change Payment method"
                testID="change-payment-method"
                onPress={() => {
                  onModalDismiss()
                }}
              />
            </Box>
          </Box>
          <Spacer size={24} />
        </Box>
      </Box>
    </ModalDialog>
  )
}

export default UPI

const styles = (theme: any) => ({
  upiAppTitle: {
    fontSize: 14,
    fontWeight: '700',
    color: theme.bodyTextColor,
  } as TextProps,
  paymentProgress: {
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    lineHeight: 20,
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
    fontSize: 12,
  } as TextProps,
  upiIntentText: (isSelected: boolean) =>
  ({
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: isSelected ? theme.brandColor : (theme.bodyTextColor as ColorOptions),
  } as TextProps),
  payBtnMobile: { margin: 24, justifyContent: 'flex-end' } as BoxProps,
  separatorStyle: {
    height: 1,
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 10) as ColorOptions,
  } as BoxProps,
  mobileUpiText: {
    fontSize: 12,
    fontFamily: 'jioType-medium',
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
  } as TextProps,
})
